import { EQM2080DetailTabType } from "../Store_EQM2080_R01";

export const EQM2080_R01_EQUIPMENT_CD = {
	NICKEL_CHROME: "PLATINGLINE",
	ZINC: "PLATINGLINE2",
} as const;

export const EQM2080_R01_DETAIL_TABS = [
	{
		id: EQM2080_R01_EQUIPMENT_CD.NICKEL_CHROME as EQM2080DetailTabType,
		label: "니켈크롬라인",
		equipmentCd: EQM2080_R01_EQUIPMENT_CD.NICKEL_CHROME,
	},
	{
		id: EQM2080_R01_EQUIPMENT_CD.ZINC as EQM2080DetailTabType,
		label: "아연라인",
		equipmentCd: EQM2080_R01_EQUIPMENT_CD.ZINC,
	},
] as const;
